import { Component } from '@angular/core';
import { TgInfoBoxModule } from '@trademe/tangram';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'property-maintenance',
  templateUrl: './property-maintenance.component.html',
  styleUrls: ['./property-maintenance.component.scss'],
  standalone: true,
  imports: [TgInfoBoxModule]
})
export class PropertyMaintenanceComponent {}
